var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var NetworkManager = require('./NetworkManager.js');
var ShadowView = require('./ShadowView.js')
var DB = require('./DB.js');
var PullToRefreshScrollView = require('./wrappers/PullToRefreshScrollView-wrapper');
var Icon = require('./wrappers/ReUpIcon');
var ReUpText = require('./ReUpText');
var LinkingManager = require('./wrappers/LinkingManager');
var Keyboard = require('./wrappers/Keyboard-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKSpinner,
} = MK;

// var DBEvents = require('react-native-db-models').DBEvents

var {
  AppRegistry,
  View,
  Image,
  ScrollView,
  Easing,
  Text,
  DeviceEventEmitter,
  InteractionManager,
  StyleSheet,
  Platform,
  KeyboardAvoidingView
} = ReactNative;

var DB_UPDATE_CD = 400;

var ReUpScrollView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      responder: {},
      shadowEnabled : true,
      shouldMinimizeEmptyMessage:false,
      shouldOverlayRefreshView:false,
      renderAlternativeView:null,
      renderAlternative:false,
    }
  },

  getInitialState : function()
  {
    return {
      keyboardOffset: new Animated.Value(0),
      layout: {width:0,height:0},
      context: this.props.responder.props.appManager.getReUpScrollViewContext(),
      behavior:'padding',
      isRefreshing:true,
    }
  },

  _shouldDoUpdate: true,
  _dbUpdateSubscription: null,
  _keyboardWillHideSubscription: null,
  _keyboardWillShowSubscription: null,
  componentDidMount : function()
  {
    if( Keyboard && Platform.OS != 'web' )
    {
      this._keyboardWillShowSubscription = Keyboard.addListener('keyboardDidShow', (e) => this._keyboardWillShow(e));
      this._keyboardWillHideSubscription = Keyboard.addListener('keyboardDidHide', (e) => this._keyboardWillHide(e));
    }

    var responder = this.props.responder;
    var appManager = responder.props.appManager;
    var dataDependencies = responder.props.dataDependencies;
    var customDependencies = responder.props.customDependencies;
    var thisThing = this;
    // this.localUpdate(appManager, dataDependencies, 0, function(data)
    // {
    //   thisThing.setState(data);
    // })

    if( !NetworkManager.hasUpdated(dataDependencies) ||
        !appManager.hasUpdatedFeatureName(responder.props.featureData.name) ||
        customDependencies.length > 0 )
    {
      var thisThing = this;
      setTimeout(function()
      {
        thisThing.doOnlineUpdate();
        // InteractionManager.runAfterInteractions(() =>
        // {
        //   if(thisThing._shouldDoUpdate) thisThing.doOnlineUpdate();
        //   thisThing._shouldDoUpdate = false;
        // });
      },400);
    }

    // DBEvents.on("all", this.dbDidUpdate, this.state.context);
    //console.log("eventemitter: ",appManager._eventEmitter)
    appManager._eventEmitter.on('dbUpdated', this.dbDidUpdate, this.state.context);
    if( typeof responder.reupScrollViewDidMount !== 'undefined' )
    {
      responder.reupScrollViewDidMount(this);
    }

    this.dbDidUpdate();
  },

  componentWillReceiveProps : function(newProps)
  {
  },

  scrollTo : function(x, y)
  {
    if( this._pullToRefreshScroll ) this._pullToRefreshScroll.scrollTo(x,y);
  },

  _data : {},
  localUpdate : function(appManager, dataDependencies, index, completion)
  {
    if( index >= dataDependencies.length )
    {
      completion(this._data);
      return;
    }

    var thisDependency = dataDependencies[index];
    var thisThing = this;
    appManager.getDataType(thisDependency, function(data)
    {
      thisThing._data[thisDependency] = data;
      thisThing.localUpdate(appManager, dataDependencies, index+1, completion)
    })
  },

  updateIfDataDependenyIsNull : function(appManager, dataDependencies, index, doUpdate)
  {
    if( index >= dataDependencies.length ) return;

    var thisDependency = dataDependencies[index];
    var thisThing = this;
    DB.table(thisDependency).get_all(function(data)
    {
      if( data == null )
      {
        doUpdate();
      }
      else
      {
        thisThing.updateIfDataDependenyIsNull(appManager, dataDependencies, index+1, doUpdate);
      }
    });
  },

  componentWillUnmount : function()
  {
    if( Platform.OS != 'web' )
    {
      if( this._keyboardWillShowSubscription ) this._keyboardWillShowSubscription.remove();
      if( this._keyboardWillHideSubscription ) this._keyboardWillHideSubscription.remove();      
    }
    this.props.responder.props.appManager._eventEmitter.removeListener('dbUpdated', this.dbDidUpdate, this.state.context);

    // DBEvents.removeListener("all", this.dbDidUpdate, this.state.context);
  },

  _keyboardOffset : 0,
  _changingKeyboardOffset : null,
  setKeyboardOffset : function(keyboardOffset)
  {
    if( this._changingKeyboardOffset != null ) clearTimeout(this._changingKeyboardOffset);

    var thisThing = this;
    this._changingKeyboardOffset = setTimeout(function()
    {
      thisThing._keyboardOffset = keyboardOffset;
      Animated.spring(thisThing.state.keyboardOffset,
      {
        toValue: keyboardOffset,
        friction: 6
      }).start();
    },100);
  },

  _keyboardWillShow : function(e)
  {
    this.setKeyboardOffset(e.endCoordinates.height);
  },

  _keyboardWillHide : function(e)
  {
    this.setKeyboardOffset(0);
  },

  _DID_UPDATE_CD: 600,
  _didUpdateTimeout: null,
  didUpdate : function(data)
  {
    if( this._didUpdateTimout != null ) clearTimeout(this._didUpdateTimout);

    var thisThing = this;
    this._didUpdateTimeout = setTimeout(function()
    {
      thisThing._didUpdateTimout = null;
      if( typeof thisThing._pullToRefreshScroll === 'undefined' ) return;
      thisThing._pullToRefreshScroll.setIsRefreshing(false);

      // thisThing.props.responder.didUpdate(data);
      // thisThing.props.responder.props.appManager.setData(data, function()
      // {
      // });
    },this._DID_UPDATE_CD)
  },

  didFailUpdate : function()
  {
    if( this._pullToRefreshScroll ) this._pullToRefreshScroll.setIsRefreshing(false);
    if( this.props.responder.didFailUpdate ) this.props.responder.didFailUpdate();
  },

  _dbCDTimeout : null,
  _hasUpdated : false,
  dbDidUpdate : function()
  {
    var thisThing = this;
    var responder = this.props.responder;
    var appManager = responder.props.appManager;
    var dataDependencies = responder.props.dataDependencies;
    if( typeof responder.props.allDependencyKeys !== 'undefined')
    {
      dataDependencies = responder.props.allDependencyKeys;
    }
    if( this._dbCDTimeout != null ) clearTimeout(this._dbCDTimeout)
    this._dbCDTimeout = setTimeout(function()
    {
      appManager.getDataTypes(dataDependencies, function(data)
      {
        responder.didUpdate(data);
      })
      thisThing._dbCDTimeout = null;
    }, !this._hasUpdated ? 100 : DB_UPDATE_CD);
    this._hasUpdated = true;
  },

  _isShowingUpdateAlert:false,
  doOnlineUpdate : function()
  {
    var thisThing = this;
    this.setState({isRefreshing:true});
    var responder = thisThing.props.responder;
    var appManager = responder.props.appManager;
    var appActions = typeof responder.props.appActions !== 'undefined' ? responder.props.appActions : null;

    if( responder.props.dataDependencies.length <= 0 && responder.props.customDependencies.length <= 0 )
    {
      return;
    }

    if( responder.props.dataDependencies.length > 0 )
    {
      NetworkManager.update(appManager, responder.props.dataDependencies, function(data, error)
      {
        if( typeof error !== 'undefined' && error.code == 1 && appActions != null ) // soft update
        {
          appManager.shouldSoftUpdateAlert(function(shouldAlert)
          {
            if( shouldAlert )
            {
              appActions.showLocalizedAlert("VERSION_SOFT_ALERT_TITLE", "VERSION_SOFT_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function()
              {
                appActions.hideAlert();
              }, function()
              {
                var url = Platform.OS == 'ios' ? error.AppStoreURL : error.PlayStoreURL;
                LinkingManager.openURL(url)
              }], function()
              {
                appActions.hideAlert();
              })
            }
          });
        }
        if( responder.props.customDependencies.length > 0 )
        {
          NetworkManager.retrieveCustomDataDependencies(appManager, responder.props.customDependencies, data, function(newData)
          {
            for( var key in newData ) data[key] = newData[key];
            thisThing.didUpdate(data);
            appManager.setData(newData, function()
            {
              setTimeout(()=>
              {
                thisThing.setState({isRefreshing:false});
              }, 1000);
            })
          });
        }
        else
        {
          thisThing.didUpdate(data);
          appManager.setData(data, function()
          {
            setTimeout(()=>
            {
              thisThing.setState({isRefreshing:false});
            }, 1000);
          })
        }
      }, function(result)
      {
        setTimeout(()=>
        {
          thisThing.setState({isRefreshing:false});
        }, 1000);
        if( result.code == 1 && appActions != null ) // soft update
        {
          appManager.shouldSoftUpdateAlert(function(shouldAlert)
          {
            if( shouldAlert )
            {
              appActions.showLocalizedAlert("VERSION_SOFT_ALERT_TITLE", "VERSION_SOFT_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function()
              {
                appActions.hideAlert();
              }, function()
              {
                var url = Platform.OS == 'ios' ? result.AppStoreURL : result.PlayStoreURL;
                LinkingManager.openURL(url)
              }], function()
              {
                appActions.hideAlert();
              })
            }
          });
        }
        else if( result.code == -21 && appActions != null ) // password changed elsewhere
        {
          appActions.checkErrorCodeAndReturnIfHandled(result.code)
        }
        else if( result.code == -27 && appActions != null ) // hard update
        {
          appActions.showLocalizedAlert("VERSION_HARD_ALERT_TITLE", "VERSION_HARD_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
          {
            var url = Platform.OS == 'ios' ? result.AppStoreURL : result.PlayStoreURL;
            LinkingManager.openURL(url)
          }], function()
          {
          }, false, true)
        }
        else if( result.code == -26 && appActions != null ) // app disabled
        {
          appActions.showLocalizedAlert("VERSION_DISABLED_ALERT_TITLE", "VERSION_DISABLED_BODY_ALERT", [], [function()
          {
          }], function()
          {
          }, false, true)
        }
        else if( result.code == -72 && appActions != null ) // user disabled
        {
          appActions.showLocalizedAlert("VERSION_DISABLED_ALERT_TITLE", result.message, [], [function()
          {
          }], function()
          {
          }, false, true)
        }
        else
        {
          thisThing.didFailUpdate(result);
        }
      })
    }

    if( responder.props.customDependencies.length > 0 )
    {
      thisThing.setState({isRefreshing:true});
      NetworkManager.retrieveCustomDataDependencies(appManager, responder.props.customDependencies, {}, function(newData)
      {
        thisThing.didUpdate(newData);
        appManager.setData(newData, function()
        {
          setTimeout(()=>
          {
            thisThing.setState({isRefreshing:false});
          }, 1000);
        }, false)
      });
    }
  },

  didScroll: function(info)
  {
    if( typeof info.nativeEvent.contentOffset == 'undefined' )
    {
      return;
    }
    var offset = info.nativeEvent.contentOffset.y;
    if( this._ref_shadowView )
    {
      if( offset < 5)
      {
        this._ref_shadowView.fadeOut();
      }
      else
      {
        this._ref_shadowView.fadeIn();
      }

    }

    if( typeof this.props.onScroll === 'function' )
    {
      this.props.onScroll(info);
    }
  },

  setRefreshEnabled: function(refreshEnabled)
  {
    if( this._pullToRefreshScroll ) this._pullToRefreshScroll.setRefreshEnabled(refreshEnabled);
  },

  render: function()
  {
    var reUpScrollView = this;
    var { responder, children, featureName, shouldOverlayRefreshView, renderAlternative, renderAlternativeView, ...other } = reUpScrollView.props;

    var appManager = responder.props.appManager;
    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var locManager = appManager.getLocalizationManager();
    var pullToRefreshStatement = locManager.localizedStringForKey("PULL_TO_REFRESH_STATEMENT");
    var releaseToRefreshStatement = locManager.localizedStringForKey("RELEASE_TO_REFRESH_STATEMENT");
    var refreshingStatement = locManager.localizedStringForKey("REFRESHING_STATEMENT");
    var isEmptyPostfix = typeof this.props.isEmptyPostfix !== 'undefined' ? this.props.isEmptyPostfix : locManager.localizedStringForKey("IS_EMPTY_POSTFIX");

    var thisThing = this;

    if( this.props.shadowEnabled && (typeof responder.props.extras === 'undefined' || responder.props.extras == null || typeof responder.props.extras.shadowEnabled === 'undefined' || responder.props.extras.shadowEnabled == true) )
    {
      if( typeof other.onScroll === 'function' )
      {
        var onScroll = other.onScroll;
        other.onScroll = function(info)
        {
          thisThing.didScroll(info);
          onScroll(info);
        }
      }
      else if( typeof other.onScroll === 'undefined' )
      {
        other.onScroll = thisThing.didScroll;
      }
    }

    var isEmpty = ((typeof children === 'undefined' || children == null || children.length <= 0) || (typeof this.props.isEmpty !== 'undefined' && this.props.isEmpty)) && (typeof featureName !== 'undefined' && featureName.length > 0);
    var isRefreshing = this.state.isRefreshing;

    return (
      <View {...other} style={{flexDirection:'column', flex:1}} onLayout={(info) =>
        {
          if( info.nativeEvent.layout.width != thisThing.state.layout.width || info.nativeEvent.layout.height != thisThing.state.layout.height )
          {
            thisThing.setState({layout:info.nativeEvent.layout})
            responder.setState({layout:info.nativeEvent.layout})
          }
        }}>
        <PullToRefreshScrollView
          color1={headerColor}
          color2={headerTitleColor}
          color3={headerIconColor}
          keyboardShouldPersistTaps={'always'}
          keyboardDismissMode={"interactive"}
          didStartRefreshing={(ptr) => { thisThing.doOnlineUpdate() }}
          ref={(a)=>{if( thisThing._pullToRefreshScroll != null ) thisThing._pullToRefreshScroll = a}} key="pullToRefreshScroll"
          shouldOverlayRefreshView={shouldOverlayRefreshView}
          pullRefreshView={
            <View style={[styles.outerContainer, {backgroundColor:headerIconColor}]}>
              <View style={[styles.innerContainer]}>
                <ReUpText appManager={appManager} style={[styles.pullTextStyle, {color:headerColor}]}>{pullToRefreshStatement}</ReUpText>
              </View>
            </View>
          }
          releaseRefreshView={
            <View style={[{flex:1},styles.outerContainer, {backgroundColor:headerIconColor}]}>
              <View style={[{flex:1},styles.innerContainer]}>
                <ReUpText appManager={appManager} style={[styles.releaseTextStyle, {color:headerColor}]}>{releaseToRefreshStatement}</ReUpText>
              </View>
            </View>
          }
          refreshingView={
            <View style={[styles.outerContainer, {backgroundColor:headerIconColor}]}>
              <View style={[styles.innerContainer]}>
                <ReUpText appManager={appManager} style={[styles.refreshingTextStyle, {color:headerColor}]}>{refreshingStatement}</ReUpText>
                <MKSpinner style={styles.progress} strokeColor={[headerColor]} />
              </View>
            </View>
          } {...other} style={{flex:1}}>
          {
            renderAlternative && renderAlternativeView != null ?
              renderAlternativeView()
            :
              children
          }
          {
            isEmpty && !isRefreshing ?
              <View key="emp" style={{backgroundColor:generalColor, height:this.props.shouldMinimizeEmptyMessage ? -1 : 400, flexDirection:'column', alignItems:'center', justifyContent:'center', marginTop:this.props.shouldMinimizeEmptyMessage ? 20 : 0}}>
                <Icon name={appManager.getFeatureForName(featureName).data.icon.replace("fa-", "")} size={62} color={generalTitleColor}/>
                <View style={{flexDirection:'column', justifyContent:'center', alignItems:'center', padding:20, height:80}}>
                  <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} isTitle={true}>{appManager.getFeatureForName(featureName).data.title}</ReUpText>
                  <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{textAlign:'center'}}>{isEmptyPostfix}</ReUpText>
                </View>
              </View>
            : null
          }
          {
            isEmpty && isRefreshing ?
              <View key="emp" style={{backgroundColor:generalColor, height:this.props.shouldMinimizeEmptyMessage ? -1 : 400, flexDirection:'column', alignItems:'center', justifyContent:'center', marginTop:this.props.shouldMinimizeEmptyMessage ? 20 : 0}}>
                <Icon name={appManager.getFeatureForName(featureName).data.icon.replace("fa-", "")} size={62} color={generalTitleColor}/>
                <View style={{flexDirection:'column', justifyContent:'center', alignItems:'center', padding:20, height:80}}>
                  <MKSpinner style={styles.progress} strokeColor={[generalTitleColor]} />
                </View>
              </View>
            : null
          }
          <Animated.View style={{height:this.state.keyboardOffset, alignSelf:'stretch', backgroundColor:'transparent'}} />
        </PullToRefreshScrollView>
        <ShadowView ref={(c) => { this._ref_shadowView = c; }} shouldDrop={true} appManager={appManager} style={{position:'absolute', backgroundColor:'transparent', top:0, left:0, right:0, height:4}} />
      </View>
    )
  }
});

var styles = StyleSheet.create({
  innerContainer:{
    height:50,
    flexDirection:'row',
    alignItems:'center',
    justifyContent:'center',
    flex:1
  },
  outerContainer:{
    height:1000,
    flexDirection:'row',
    alignItems:'flex-end',
  },
  refreshingTextStyle:{
    marginRight:10,
  },
  progress: {
    backgroundColor : 'transparent',
  },
});

module.exports = ReUpScrollView;
